import React, { useEffect } from "react";
import Hero from "../components/Home/Hero/Hero";
import Marquee from "../components/Home/  Marquee/Marquee";
import MiddleText from "../components/Home/MiddleText/MiddleText";
import CollectionsShowcase from "../components/Home/CollectionsShowcase/CollectionsShowcase";
import WearLormami from "../components/Home/WearLormami/WearLormami";
import ShopBy from "../components/Home/ShopBy/ShopBy";
import PreorderTeaser from "../components/Home/Preorder/PreorderTeaser";
import BestSellers from "../components/Home/BestSellers/BestSellers";
import SocailMedia from "../components/Home/SocialMedia/SocailMedia";
import Footer from "../components/Home/Footer/Footer";

const Home = () => {
  // Support deep links like /#collections and /#preorder
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) {
      const timer = setTimeout(() => el.scrollIntoView(), 100);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div>
      <Hero />
      <Marquee />
      <MiddleText />
      <CollectionsShowcase />
      <WearLormami />
      <ShopBy />
      <PreorderTeaser />
      <BestSellers />
      <SocailMedia />
      <Footer />
    </div>
  );
};

export default Home;
